export default function printStylesCount(stylesCount: number): string | null {
    if (stylesCount === 0) {
        return null;
    }
    return stylesCount === 1 ? `${stylesCount} style` : `${stylesCount} styles`;
}
